export var metrics_t;
(function (metrics_t) {
    metrics_t[metrics_t["risk_licenses_k"] = 0] = "risk_licenses_k";
    metrics_t[metrics_t["risk_secrets_k"] = 1] = "risk_secrets_k";
    metrics_t[metrics_t["risk_vulnerabilities_k"] = 2] = "risk_vulnerabilities_k";
    metrics_t[metrics_t["risk_hardening_k"] = 3] = "risk_hardening_k";
    metrics_t[metrics_t["risk_tampering_k"] = 4] = "risk_tampering_k";
    metrics_t[metrics_t["risk_malware_k"] = 5] = "risk_malware_k";
    metrics_t[metrics_t["metrics_cnt_k"] = 6] = "metrics_cnt_k";
})(metrics_t || (metrics_t = {}));
export var status_t;
(function (status_t) {
    status_t[status_t["status_pass_k"] = 0] = "status_pass_k";
    status_t[status_t["status_warning_k"] = 1] = "status_warning_k";
    status_t[status_t["status_fail_k"] = 2] = "status_fail_k";
    status_t[status_t["status_cnt_k"] = 3] = "status_cnt_k";
})(status_t || (status_t = {}));
export var policy_metrics_t;
(function (policy_metrics_t) {
    policy_metrics_t[policy_metrics_t["issues_total_k"] = 0] = "issues_total_k";
    policy_metrics_t[policy_metrics_t["issues_pass_k"] = 1] = "issues_pass_k";
    policy_metrics_t[policy_metrics_t["issues_warning_k"] = 2] = "issues_warning_k";
    policy_metrics_t[policy_metrics_t["issues_fail_k"] = 3] = "issues_fail_k";
    policy_metrics_t[policy_metrics_t["issues_high_k"] = 4] = "issues_high_k";
    policy_metrics_t[policy_metrics_t["issues_medium_k"] = 5] = "issues_medium_k";
    policy_metrics_t[policy_metrics_t["issues_low_k"] = 6] = "issues_low_k";
    policy_metrics_t[policy_metrics_t["metrics_cnt_k"] = 7] = "metrics_cnt_k";
})(policy_metrics_t || (policy_metrics_t = {}));
export var vulnerability_metrics_t;
(function (vulnerability_metrics_t) {
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_total_k"] = 0] = "vuln_total_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_critical_k"] = 1] = "vuln_critical_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_high_k"] = 2] = "vuln_high_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_medium_k"] = 3] = "vuln_medium_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_low_k"] = 4] = "vuln_low_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_exploit_k"] = 5] = "vuln_exploit_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_named_k"] = 6] = "vuln_named_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_mandate_k"] = 7] = "vuln_mandate_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_malware_k"] = 8] = "vuln_malware_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_fixable_k"] = 9] = "vuln_fixable_k";
    vulnerability_metrics_t[vulnerability_metrics_t["vuln_triaged_k"] = 10] = "vuln_triaged_k";
    vulnerability_metrics_t[vulnerability_metrics_t["metrics_cnt_k"] = 11] = "metrics_cnt_k";
})(vulnerability_metrics_t || (vulnerability_metrics_t = {}));
export var license_metrics_t;
(function (license_metrics_t) {
    license_metrics_t[license_metrics_t["undeclared_k"] = 0] = "undeclared_k";
    license_metrics_t[license_metrics_t["public_domain_k"] = 1] = "public_domain_k";
    license_metrics_t[license_metrics_t["permissive_k"] = 2] = "permissive_k";
    license_metrics_t[license_metrics_t["weak_copyleft_k"] = 3] = "weak_copyleft_k";
    license_metrics_t[license_metrics_t["copyleft_k"] = 4] = "copyleft_k";
    license_metrics_t[license_metrics_t["freeware_k"] = 5] = "freeware_k";
    license_metrics_t[license_metrics_t["shareware_k"] = 6] = "shareware_k";
    license_metrics_t[license_metrics_t["freemium_k"] = 7] = "freemium_k";
    license_metrics_t[license_metrics_t["non_commercial_k"] = 8] = "non_commercial_k";
    license_metrics_t[license_metrics_t["proprietary_k"] = 9] = "proprietary_k";
    license_metrics_t[license_metrics_t["license_cnt_k"] = 10] = "license_cnt_k";
})(license_metrics_t || (license_metrics_t = {}));
//# sourceMappingURL=sdlcMetadataTypes.js.map